import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/mixins/import'
import { register as registerCustomElements } from '@/helper/customElementsHelper'
import * as Store from '@/store'
import vueCustomElement from 'vue-custom-element'
import { createProvider } from '@/apollo'

import MessageView from '@/components/generic/MessageView/MessageList'
import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'

import Config from '../config/lidl'
import { globalStoreConfig } from '@/store/config'
import { storeConfig } from '@/store/config/lidl'

import CurrentMsisdn from '@/components/process/generic/Customer/Msisdn/CurrentMsisdn'
import ActivationWrapper from '@/components/process/LIDL/Activation/Wrapper/ActivationWrapper.vue'
import LoginComponent from '@/components/process/generic/Authentication/Login/LoginComponent'
import ForgotPasswordWrapper from '@/components/process/generic/Password/ForgotPassword/ForgotPasswordWrapper'
import ResetPasswordConfirmationWrapper from '@/components/process/generic/Password/ResetPassword/ResetPasswordConfirmationWrapper'
import ProductInformationItemVersions
  from '@/components/process/generic/ProductInformationSheet/ProductInformationItemVersions'
import ProductInformationSheetsWrapper
  from '@/components/process/generic/ProductInformationSheet/ProductInformationSheetsWrapper'
import LogOutLink from './components/process/generic/Authentication/LogOut/LogOutLink'
import TariffDetailModal from './components/process/LIDL/Activation/Tariff/TariffDetailModal.vue'
import TariffInfoModal from './components/process/generic/Tariff/generic/CurrentTariff/TariffInfoModal'
import WebSessionTariffModal from './components/process/generic/Tariff/lidl/WebSessionTariffModal'
import CurrentTariff from './components/process/generic/Tariff/generic/CurrentTariff/CurrentTariff'
import BalanceTariffInfoWrapper from '@/components/process/generic/Tariff/lidl/BalanceTariffInfoWrapper'
import SendVerificationMail from '@/components/process/generic/Email/EmailVerification/SendVerificationMail'
import EmailConfirmationWrapper from '@/components/process/generic/Email/EmailConfirmation/EmailConfirmationWrapper'
import EmailVerificationNotification from '@/components-v2/flows/LIDL/Email/EmailVerificationNotification.vue'
import TeaserText from '@/components/generic/TeaserText'
import OppwaCC from '@/components/generic/OppwaCC'
import VoucherTopUpWrapper from '@/components/process/generic/TopUp/Voucher/lidl/VoucherTopUpWrapper'
import ConsumptionsWrapper from '@/components/process/generic/Consumption/lidl/ConsumptionsWrapper'
import ConsumptionItemProgressWithDescription from '@/components/process/generic/Consumption/ConsumptionItemProgressWithDescription'
import ChangeAutoTopUpWrapper from '@/components/process/generic/TopUp/ChangeAutoTopUp/lidl/ChangeAutoTopUpWrapper'
import ProcessConfirmModal from '@/components/generic/ProcessConfirmModal'
import SingleTopUpBtnWrapper from './components/process/generic/TopUp/SingleTopUp/lidl/SingleTopUpBtnWrapper'
import SingleTopUpPaypalWrapper from './components/process/generic/TopUp/SingleTopUp/lidl/SingleTopUpPaypalWrapper'
import BalanceInfo from '@/components/process/generic/Balance/BalanceInfo'
import ChangePasswordWrapper from './components/process/generic/Password/ChangePassword/lidl/ChangePasswordWrapper'
import ChangeEvnWrapper from '@/components/process/generic/ItemisedBills/lidl/ChangeEvnWrapper'
import EVNBillsOverview from './components/process/generic/ItemisedBills/lidl/EVNBillsOverview'
import GDPRDataWrapper from './components/process/generic/GDPRData/GDPRDataWrapper'
import CheckSimCard from './components/process/LIDL/SimCard/CheckSimCard/View'
import ConsentWrapper from '@/components/process/generic/Consent/lidl/ConsentWrapper'
import PersonalDataWrapper from '@/components/process/LIDL/PersonalData/Wrapper/PersonalDataWrapper'
import ChangePaymentWrapper from './components/process/LIDL/Payment/Wrapper/ChangePaymentWrapper.vue'
import PassivateSimCardWrapper from './components/process/generic/SimCard/PassivateSimCard/PassivateSimCardWrapper'
import SimOrderStatusWrapper from './components/process/generic/SimCard/SimOrder/lidl/SimOrderStatusWrapper'
import FriendNotification from './components/process/LIDL/Notification/FriendNotification'
import TariffInfoWrapper from '@/components/process/generic/PersonalData/bild/TariffInfoWrapper'
import SimOrderWrapper from './components/process/generic/SimCard/SimOrder/lidl/SimOrderWrapper'
import MnpOutStatus from './components/process/generic/Mnp/MnpOutStatus/ShowMnpOutStatus'
import TariffOptionsWrapper from '@/components/process/generic/Tariff/generic/TariffOptions/TariffOptionsWrapper'
import MnpInWrapper from '@/components/process/generic/Mnp/MnpIn/lidl/MnpInWrapper'
import TariffsWrapper from './components/process/generic/Tariff/generic/TariffsWrapper'
import FriendNotificationWrapper from '@/components/process/LIDL/Notification/FriendNotificationWrapper'
import Notification from '@/components/process/generic/Notification/Notification'
import TariffOptionsOverviewWrapper from '@/components/process/generic/Tariff/generic/TariffOptions/TariffOptionsOverviewWrapper'
import FeedbackProcessWrapper from './components/process/generic/Feedback/FeedbackProcessWrapper'
import ConsumptionInfoPopoverWithDescription
  from '@/components/process/generic/Consumption/ConsumptionInfoPopoverWithDescription'
import DeviceConfigurator from '@/components/process/generic/DeviceConfigurator/DeviceConfigurator'
import TriggerTariffInfo from './components/process/generic/Tariff/lidl/TriggerTariffInfo'
import CancellationWrapper from '@/components/process/LIDL/Cancellation/CancellationWrapper'
import ContractSummary from '@/components/process/generic/Tariff/generic/ContractSummary'
import ExternalOrderContractSummary from '@/components/process/generic/ExternalOrderContractSummary/DownloadContractSummary'
import ESimSetup from '@/components/process/LIDL/SimCard/ESimSetup.vue'
import CustomerDocumentListOverview from '@/components/process/generic/CustomerDocumentList/CustomerDocumentListOverview.vue'
import CustomerDocumentBanner from '@/components/process/generic/CustomerDocumentList/CustomerDocumentBanner.vue'

import ActivationWrapperV2 from '@/components-v2/flows/LIDL/Activation/Wrapper/ActivationWrapper.vue'
import AppStoreCard from '@/components-v2/flows/LIDL/App/AppStoreCard.vue'
import BalanceInfoV2 from '@/components-v2/flows/LIDL/Balance/BalanceInfo'
import BookedTariffOptionsV2 from '@/components-v2/flows/LIDL/Tariff/generic/BookedTariff/BookedTariffOptions.vue'
import CancellationWrapperV2 from './components-v2/flows/LIDL/Cancellation/CancellationWrapper.vue'
import ChangeAutoTopUpWrapperV2 from '@/components-v2/flows/LIDL/TopUp/ChangeAutoTopUp/lidl/ChangeAutoTopUpWrapper'
import ChangePasswordWrapperV2 from '@/components-v2/flows/LIDL/Password/ChangePassword/lidl/ChangePasswordWrapper'
import ChangePaymentWrapperV2 from '@/components-v2/flows/LIDL/Payment/Wrapper/ChangePaymentWrapper.vue'
import CheckSimCardV2 from '@/components-v2/flows/LIDL/SimCard/CheckSimCard/View'
import ConsumptionsWrapperV2 from '@/components-v2/flows/LIDL/Consumption/ConsumptionsWrapper.vue'
import ConsentWrapperV2 from '@/components-v2/flows/LIDL/Consent/ConsentWrapper'
import CustomerDocumentBannerV2 from '@/components-v2/flows/LIDL/CustomerDocumentList/CustomerDocumentBanner.vue'
import CustomerDocumentListOverviewV2 from '@/components-v2/flows/LIDL/CustomerDocumentList/CustomerDocumentListOverview.vue'
import CurrentTariffV2 from '@/components-v2/flows/LIDL/Tariff/CurrentTariff/CurrentTariff'
import ESimSetupV2 from '@/components-v2/flows/LIDL/SimCard/ESimConfiguration/ESimSetup.vue'
import EvnWrapperV2 from '@/components-v2/flows/LIDL/Evn/Wrapper/EvnWrapperV2.vue'
import ForgotPasswordWrapperV2 from '@/components-v2/flows/LIDL/Password/ForgotPassword/ForgotPasswordWrapper'
import FriendNotificationV2 from '@/components-v2/flows/LIDL/Notification/FriendNotification'
import FriendNotificationWrapperV2 from '@/components-v2/flows/LIDL/Notification/FriendNotificationWrapper'
import GDPRDataWrapperV2 from '@/components-v2/flows/LIDL/GDPRData/GDPRDataWrapper'
import LogOutV2Button from '@/components-v2/flows/LIDL/Authentication/LogOut/LogOut.vue'
import LoginComponentV2 from '@/components-v2/flows/LIDL/Authentication/Login/LoginComponent.vue'
import LoginInfoBox from '@/components-v2/flows/LIDL/Authentication/Login/LoginInfoBox.vue'
import MessageViewV2 from '@/components-v2/flows/LIDL/MessageView/MessageList'
import MnpInWrapperV2 from '@/components-v2/flows/LIDL/Mnp/MnpIn/MnpInWrapper.vue'
import MnpOutStatusV2 from '@/components-v2/flows/LIDL/Mnp/MnpOutStatus/ShowMnpOutStatus'
import OverviewBalanceInfo from '@/components-v2/flows/LIDL/Overview/BalanceInfo.vue'
import OverviewTariffInfo from '@/components-v2/flows/LIDL/Overview/TariffInfo.vue'
import PassivateSimCardWrapperV2 from '@/components-v2/flows/LIDL/SimCard/PassivateSimCard/PassivateSimCardWrapper'
import PersonalDataWrapperV2 from '@/components-v2/flows/LIDL/PersonalData/Wrapper/PersonalDataWrapper'
import ProductInformationItemVersionsV2 from '@/components-v2/flows/LIDL/ProductInformationSheet/ProductInformationItemVersions'
import ProductInformationSheetsWrapperV2 from '@/components-v2/flows/LIDL/ProductInformationSheet/ProductInformationSheetsWrapper'
import ResetPasswordConfirmationWrapperV2 from '@/components-v2/flows/LIDL/Password/ResetPassword/ResetPasswordConfirmationWrapper'
import ServiceOptions from '@/components-v2/generic/ServiceOptions.vue'
import SimCardWrapperV2 from '@/components-v2/flows/LIDL/SimCard/SimCardWrapper.vue'
import SimOrderStatusWrapperV2 from '@/components-v2/flows/LIDL/SimCard/SimOrder/lidl/SimOrderStatusWrapper'
import SingleDirectTopUpWrapper from '@/components-v2/flows/LIDL/TopUp/SingleTopUp/lidl/SingleDirectTopUpWrapper'
import SingleTopUpPaypalWrapperV2 from '@/components-v2/flows/LIDL/TopUp/SingleTopUp/lidl/SingleTopUpPaypalWrapper'
import TariffOptionsOverviewWrapperV2 from '@/components-v2/flows/LIDL/Tariff/generic/TariffOptions/TariffOptionsOverviewWrapper'
import VoucherTopUpWrapperV2 from '@/components-v2/flows/LIDL/TopUp/Voucher/lidl/VoucherTopUpWrapper'

import CustomModalWrapper from '@/components/generic/CustomModalWrapper.vue'
import VueSsrCarousel from 'vue-ssr-carousel'

const API_BASE_URL = process.env.VUE_APP_LIDL_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_LIDL_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

const TRIGGER_SESSION_TRANSFER = 'getSessionStorage'
const TRANSFER_KEY = 'sessionStorage'

Vue.use(Config, {
  apiUrl: API_BASE_URL
})

let store

// transfers sessionStorage from one tab to another

function sessionStorageTransfer (event) {
  if (!event) { event = window.event } // ie suq
  if (!event.newValue) return
  // do nothing if no value to work with
  if (event.key === TRIGGER_SESSION_TRANSFER) {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem(TRANSFER_KEY, JSON.stringify(sessionStorage.getItem('portal-session')))
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem(TRANSFER_KEY) // <- could do short timeout as well.
  } else if (event.key === TRANSFER_KEY) {
    // another tab sent data <- get it
    if (sessionStorage.getItem('portal-session') != null) {
      // other tab was quicker. ignore this one
      return
    }
    const data = JSON.parse(event.newValue)
    sessionStorage.setItem('portal-session', data)
    store = Store.createStore({
      ...globalStoreConfig,
      ...storeConfig
    })
    initializeApplication()
  }
}

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener('storage', sessionStorageTransfer, false)
} else {
  window.attachEvent('onstorage', sessionStorageTransfer)
}
// The opened tab requests the session storage content
// this is performed async
// wann wollen wir abrufen?
//   neuer Tab!
//   1. aktuell keine portal-session
//   2. (window.history = 1)
if (sessionStorage.getItem('portal-session') == null) {
  localStorage.setItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  localStorage.removeItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  // if there is no other tab open, nobody will answer :(
  // so we have to set a timeout to do the stuff ourself :)
  setTimeout(function () {
    if (sessionStorage.getItem('portal-session') == null) {
      initializeStore()
      initializeApplication()
    }
  }, 100)
} else {
  initializeStore()
  initializeApplication()
}
// End transfers sessionStorage from one tab to another

function initializeStore () {
  store = Store.createStore({
    ...globalStoreConfig,
    ...storeConfig
  })
  store.commit('selectBrand', 'lidl')
  store.commit('selectRetailerId', '40006311')
  store.commit('selectType', 'DELIVERY')
  // ggf. hier auf ENVs gehen, wenn nötig -> process.env.LIDL_CLIENT_ID + LIDL_CLIENT_SECRET
  store.commit('selectClient', { id: 'lidl', secret: 'lidl' })
  store.commit('selectBaseUrl', API_BASE_URL)
}

function initializeApplication () {
  const apolloProvider = createProvider(store, {
    autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
    httpEndpoint: GRAPHQL_HTTP,
    restEndpoint: API_BASE_URL
  })

  Vue.component('dyn-slot', DynSlot)

  Vue.config.productionTip = false

  Vue.config.ignoredElements = [
    // Use a `RegExp` to ignore all elements that start with "ion-"
    // 2.5+ only
    // /^ion-/
  ]

  Vue.use(vueCustomElement)
  Vue.component('dyn-slot', DynSlot)
  Vue.component('ProductInformationItem', ProductInformationItemVersions)
  Vue.component('ProductInformationItemV2', ProductInformationItemVersionsV2)
  Vue.component('ConsumptionItem', ConsumptionItemProgressWithDescription)
  Vue.component('ConsumptionInfoPopover', ConsumptionInfoPopoverWithDescription)
  Vue.component('FriendNotification', FriendNotification)
  Vue.component('FriendNotificationV2', FriendNotificationV2)

  registerCustomElements({
    // generics
    'app-tooltip': Tooltip,
    'app-teaser-text': TeaserText,
    'app-current-msisdn': CurrentMsisdn,
    'app-current-tariff': CurrentTariff,
    'app-current-tariff-v2': CurrentTariffV2,
    'app-friend-notification-wrapper-v2': FriendNotificationWrapperV2,
    // processes
    'app-balance-tariff-info-wrapper': BalanceTariffInfoWrapper,
    'app-balance-info': BalanceInfo,
    'app-overview-balance-info': OverviewBalanceInfo,
    'app-overview-tariff-info': OverviewTariffInfo,
    'app-balance-info-v2': BalanceInfoV2,
    'app-message-view': MessageView,
    'app-message-view-v2': MessageViewV2,
    'app-notification': Notification,
    'app-activation': ActivationWrapper,
    'app-activation-v2': ActivationWrapperV2,
    'app-login': LoginComponent,
    'app-login-v2': LoginComponentV2,
    'app-logout': LogOutLink,
    'app-logout-v2': LogOutV2Button,
    'app-oppwa': OppwaCC,
    'app-change-password-wrapper': ChangePasswordWrapper,
    'app-change-password-wrapper-v2': ChangePasswordWrapperV2,
    'app-forgot-password-wrapper': ForgotPasswordWrapper,
    'app-forgot-password-wrapper-v2': ForgotPasswordWrapperV2,
    'app-change-personal-data-wrapper': PersonalDataWrapper,
    'app-personal-data-wrapper-v2': PersonalDataWrapperV2,
    'app-reset-password-confirmation-wrapper': ResetPasswordConfirmationWrapper,
    'app-reset-password-confirmation-wrapper-v2': ResetPasswordConfirmationWrapperV2,
    'app-product-information-sheets': ProductInformationSheetsWrapper,
    'app-product-information-sheets-v2': ProductInformationSheetsWrapperV2,
    'app-activation-tariff-info-modal': TariffInfoModal,
    'app-websession-tariff-modal': WebSessionTariffModal,
    'app-activation-tariff-detail-modal': TariffDetailModal,
    'app-send-verification-mail': SendVerificationMail,
    'app-email-confirmation-wrapper': EmailConfirmationWrapper,
    'app-voucher-top-up-wrapper': VoucherTopUpWrapper,
    'app-voucher-top-up-wrapper-v2': VoucherTopUpWrapperV2,
    'app-process-confirm-modal': ProcessConfirmModal,
    'app-consumptions': ConsumptionsWrapper,
    'app-consumptions-v2': ConsumptionsWrapperV2,
    'app-change-auto-top-up-wrapper': ChangeAutoTopUpWrapper,
    'app-change-auto-top-up-wrapper-v2': ChangeAutoTopUpWrapperV2,
    'app-single-top-up-btn-wrapper': SingleTopUpBtnWrapper,
    'app-single-direct-top-up-wrapper-v2': SingleDirectTopUpWrapper,
    'app-single-top-up-paypal-wrapper': SingleTopUpPaypalWrapper,
    'app-single-top-up-paypal-wrapper-v2': SingleTopUpPaypalWrapperV2,
    'app-evn-settings-wrapper': ChangeEvnWrapper,
    'app-evn-settings-wrapper-v2': EvnWrapperV2,
    'app-evn-bills-overview': EVNBillsOverview,
    'app-check-sim-card': CheckSimCard,
    'app-check-sim-card-v2': CheckSimCardV2,
    'app-gdpr-data-wrapper': GDPRDataWrapper,
    'app-gdpr-data-wrapper-v2': GDPRDataWrapperV2,
    'app-consent-wrapper': ConsentWrapper,
    'app-consent-wrapper-v2': ConsentWrapperV2,
    'app-payment-change-wrapper': ChangePaymentWrapper,
    'app-payment-change-wrapper-v2': ChangePaymentWrapperV2,
    'app-passivate-sim-card-wrapper': PassivateSimCardWrapper,
    'app-passivate-sim-card-wrapper-v2': PassivateSimCardWrapperV2,
    'app-sim-card-wrapper-v2': SimCardWrapperV2,
    'app-sim-order-status-wrapper': SimOrderStatusWrapper,
    'app-sim-order-status-wrapper-v2': SimOrderStatusWrapperV2,
    'app-tariff-info-wrapper': TariffInfoWrapper,
    'app-sim-order-wrapper': SimOrderWrapper,
    'app-mnp-out-status': MnpOutStatus,
    'app-mnp-out-status-v2': MnpOutStatusV2,
    'app-tariff-options-wrapper': TariffOptionsWrapper,
    'app-service-options': ServiceOptions,
    'app-booked-tariff-options-v2': BookedTariffOptionsV2,
    'app-tariffs-wrapper': TariffsWrapper,
    'app-tariff-options-overview-wrapper': TariffOptionsOverviewWrapper,
    'app-tariff-options-overview-wrapper-v2': TariffOptionsOverviewWrapperV2,
    'app-mnp-in-wrapper': MnpInWrapper,
    'app-mnp-in-wrapper-v2': MnpInWrapperV2,
    'app-friend-notification-wrapper': FriendNotificationWrapper,
    'app-tnps-feedback-wrapper': FeedbackProcessWrapper,
    'app-device-configurator': DeviceConfigurator,
    'app-cancellation-wrapper': CancellationWrapper,
    'app-cancellation-v2': CancellationWrapperV2,
    'app-trigger-tariff-info': TriggerTariffInfo,
    'app-contract-summary': ContractSummary,
    'app-external-order-contract-summary': ExternalOrderContractSummary,
    'app-esim-setup': ESimSetup,
    'app-esim-setup-v2': ESimSetupV2,
    'app-customer-document-list-overview': CustomerDocumentListOverview,
    'app-customer-document-list-overview-v2': CustomerDocumentListOverviewV2,
    'app-customer-document-banner': CustomerDocumentBanner,
    'app-customer-document-banner-v2': CustomerDocumentBannerV2,
    'app-custom-modal-wrapper': CustomModalWrapper,
    'app-vue-ssr-carousel': VueSsrCarousel,
    'app-login-info-box': LoginInfoBox,
    'app-store-card': AppStoreCard,
    'app-email-verification-notification': EmailVerificationNotification
  }, store, apolloProvider)
}
